import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// MY EMPLOYEE VIEW: propagate the chosen view so the backend downgrades an
// ADMIN's privileges to their actual workflow roles for that request.
api.interceptors.request.use((config) => {
  const mode = localStorage.getItem("viewMode");
  if (mode === "employee") config.headers["X-View-Mode"] = "employee";
  return config;
});

export default api;
export { API };
